import React, {useEffect, useState} from 'react';

import './Work.scss'

import {motion} from "framer-motion";
import {client, urlFor} from "../../client";
import {AiFillEye, AiFillGithub} from "react-icons/ai";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";

function Work(props) {

    const [filters, setFilters] = useState([])
    const [activeFilter, setActiveFilter] = useState('All')
    const [works, setWorks] = useState([])
    const [filterWork, setFilterWork] = useState([])
    const [animateCard, setAnimateCard] = useState({
        y: 0,
        opacity: 1
    })

    useEffect(() => {
        const query = "*[_type == 'works']";
        client.fetch(query).then(data => {
            setWorks(data)
            setFilterWork(data)

            const filters = ['All']

            data.forEach(d => {
                d.tags.forEach(tag => {
                    if (!filters.includes(tag)){
                        filters.push(tag)
                    }
                })
            })

            setFilters(filters)
        })
    }, [])

    function handleActiveFilter(item){
        setActiveFilter(item)
        setAnimateCard([{y:100, opacity: 0}])
        setTimeout(() => {
            setAnimateCard([{y:0, opacity: 1}])

            if (item === 'All'){
                setFilterWork(works)
            } else {
                setFilterWork(works.filter(work => work.tags.includes(item)))
            }

        }, 500)
    }

    return (
        <>
            <h2 className="head-text">My <span>Portfolio</span></h2>
            <div className="app__work-filter">
                {
                    filters.map((item, index) => (
                        <div
                            key={`filter-${index}`}
                            onClick={() => handleActiveFilter(item)}
                            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : null}`}
                        >
                            {item}
                        </div>
                    ))
                }
            </div>

            <motion.div
                animate={animateCard}
                transition={{duration: 0.5, delayChildren: 0.5}}
                className="app__work-portfolio"
            >
                {
                    filterWork.map((item, index) => (
                        <div className="app__work-item app__flex" key={`work-item-${index}`}>
                            <div className="app__work-img app__flex">
                                <img src={urlFor(item.imgUrl)} alt={item.name}/>

                                <motion.div
                                    whileHover={{opacity: [0, 1]}}
                                    transition={{duration: 0.25, ease: "easeInOut", staggerChildren: 0.5}}
                                    className="app__work-hover app__flex"
                                >
                                    <a href={item.projectLink} target="_blank" rel="noreferrer">
                                        <motion.div
                                            whileInView={{scale: [0, 1]}}
                                            whileHover={{scale: [1, 0.9]}}
                                            transition={{duration: 0.25}}
                                            className="app__flex"
                                        >
                                            <AiFillEye/>
                                        </motion.div>
                                    </a>
                                    <a href={item.codeLink} target="_blank" rel="noreferrer">
                                        <motion.div
                                            whileInView={{scale: [0, 1]}}
                                            whileHover={{scale: [1, 0.9]}}
                                            transition={{duration: 0.25}}
                                            className="app__flex"
                                        >
                                            <AiFillGithub/>
                                        </motion.div>
                                    </a>
                                </motion.div>
                            </div>

                            <div className="app__work-content app__flex">
                                <h4 className="bold-text">{item.title}</h4>
                                <p className="p-text" style={{marginTop: 10}}>{item.description}</p>

                                <div className="app__work-tag app__flex">
                                    <p className="p-text">{item.tags[0]}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </motion.div>
        </>
    );
}

export default AppWrap(MotionWrap(Work, 'app__works'), 'work', 'app__primarybg');